// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"eab17c9c","253":"a6e341c2","554":"f8a828c2","743":"cf70a2ce"}[chunkId] + ".chunk.js";
};